module.exports = __webpack_public_path__ + "img/phone.5bc57b90.svg";